import {
  WSButton,
  WSElement,
  WSInfoBox,
  WSList,
  WSText
} from "@wingspanhq/fe-component-library";
import { useState } from "react";
import type { resourceEventHistoryApiSpec } from "@wingspanhq/wingspan-api-types";
import { EventContent } from "./EventContent";
import { pluralizeEventTitle } from "./pluralizeEventTitle";
import { EventGroup } from "./types";

type Props = {
  group: EventGroup & { type: "grouped" };
  isCompact?: boolean;
  drillDownResourceType?: string;
  onDrillDown?: (resource: resourceEventHistoryApiSpec.IEventResource) => void;
};

export const EventGroupContent: React.FC<Props> = props => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <WSElement>
      <WSText.ParagraphSm color="gray600">
        {pluralizeEventTitle(props.group.eventTitle, props.group.events.length)}
      </WSText.ParagraphSm>

      {isExpanded ? (
        <>
          <WSInfoBox mt="M">
            <WSList gap="M">
              {props.group.events.map(event => (
                <WSElement key={event.resourceEventId}>
                  <EventContent
                    event={event}
                    isCompact={props.isCompact}
                    drillDownResourceType={props.drillDownResourceType}
                    onDrillDown={props.onDrillDown}
                  />
                </WSElement>
              ))}
            </WSList>
          </WSInfoBox>
          <WSButton.Link
            size="S"
            ml="NONE"
            pl="NONE"
            mt="S"
            onClick={() => setIsExpanded(false)}
          >
            See less
          </WSButton.Link>
        </>
      ) : (
        <WSButton.Link
          size="S"
          ml="NONE"
          pl="NONE"
          onClick={() => setIsExpanded(true)}
        >
          See more
        </WSButton.Link>
      )}
    </WSElement>
  );
};
